// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from refresh.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function RefreshIcon(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="currentColor" fill-rule="evenodd">
        <path d="M0 8A8 8 0 1 0 11.468.79l-.868 1.8a6 6 0 1 1-5.155-.022L4.594.761A8 8 0 0 0 0 8Z" />
        <path d="M7 8.586V0h2v8.586l1.293-1.293.707-.707L12.414 8l-.707.707-3 3-.707.707-.354-.353-.353-.354-3-3L3.586 8 5 6.586l.707.707z" />
      </g>
    </svg>
  );
}
